<template>
  <v-stepper alt-labels class="echeancier-paiement my-2">
    <v-stepper-header flat>
      <v-divider></v-divider>
      <template v-for="(appel, i) in appels">
        <v-stepper-step
          :step="i"
          complete
          :complete-icon="appel.resteDu > 0 ? 'mdi-calendar' : 'mdi-check'"
          :color="appel.resteDu > 0 ? 'primary' : 'success'"
          :key="'step-' + i"
        >
          <div class="text-center caption text-uppercase grey--text">
            <div>Paiement {{ appel.resteDu > 0 ? "prévu" : "reçu" }}</div>
            <div v-if="i == 0">Avant le 31 mars</div>
            <div v-else-if="i == 1">Avant le 30 juin</div>
            <div>{{ appel.montant | money }}</div>
          </div>
        </v-stepper-step>

        <v-divider :key="'divider-' + i"></v-divider>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  props: {
    appels: { type: Array },
  },
}
</script>

<style>
.echeancier-paiement {
  border: none;
  box-shadow: none;
  max-width: 500px;
  margin: 0 auto;
}
.v-stepper.echeancier-paiement .v-stepper__label {
  display: flex;
}
.v-stepper.echeancier-paiement .v-stepper__step__step {
  height: 45px;
  width: 45px;
  min-width: 45px;
}
.v-stepper.echeancier-paiement.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 45px -60px;
}
</style>
